import React from 'react';
export function HowItWorksSection() {
  return <section id="how-it-works" className="py-24 md:py-32 border-t border-gray-100 max-w-6xl mx-auto px-6" data-id="element-123">
      <div className="grid grid-cols-1 md:grid-cols-12 gap-12" data-id="element-124">
        <div className="md:col-span-4 sticky top-20 md:static self-start z-10 bg-white pb-6 md:pb-0 -mx-6 px-6 md:mx-0 md:px-0" data-id="element-125">
          <h2 className="text-sm font-bold uppercase tracking-widest text-gray-400 mb-4" data-id="element-126">
            How it works
          </h2>
          <h3 className="text-3xl md:text-4xl font-light text-black" data-id="element-127">
            How execution changes
          </h3>
        </div>

        <div className="md:col-span-8 space-y-16" data-id="element-128">
          <div data-id="element-129">
            <h4 className="text-xl font-medium text-black mb-4" data-id="element-130">
              Close the Execution Gap
            </h4>
            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl" data-id="element-131">
              You know where you're going. But progress slows as to-dos pile up.
              That gap between conviction and movement is where momentum dies. I
              step in to close it.
            </p>
          </div>

          <div data-id="element-132">
            <h4 className="text-xl font-medium text-black mb-4" data-id="element-133">
              Break the Founder Bottleneck
            </h4>
            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl" data-id="element-134">
              When every decision runs through you, speed collapses. Not because
              you want control, but because no one else has the authority,
              clarity, or context to move things forward. My job is to extract
              what's in your head and turn it into shared execution.
            </p>
          </div>

          <div data-id="element-135">
            <h4 className="text-xl font-medium text-black mb-4" data-id="element-136">
              Choose Speed Over Comfort
            </h4>
            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl" data-id="element-137">
              Execution isn't polite. It requires saying the thing others won't,
              making real tradeoffs, and reordering time, focus, and behavior.
              Most people avoid these conversations. I don't, because speed
              depends on them.
            </p>
          </div>

          <div data-id="element-138">
            <h4 className="text-xl font-medium text-black mb-4" data-id="element-139">
              Apply Product Thinking to Chaos
            </h4>
            <p className="text-lg text-gray-600 leading-relaxed max-w-2xl" data-id="element-140">
              I treat your company like a product in beta. Bottlenecks equal
              bugs. Confusion equals friction. Execution equals the feature. I
              design only what's needed to move faster now. Nothing more.
            </p>
          </div>
        </div>
      </div>
    </section>;
}